/** AHO Room Sign In / Time Out titles. Same as iOS AHOChecklist. */

export const ahoSignIn = [
  {
    key: "signin_1",
    title:
      "Ask the patient to state their Name and Date of birth while verifying with ID band, upon entering the room or have procedure personnel verify patient identity if patient unable to participate.",
  },
  {
    key: "signin_2",
    title: "State the Procedure to be performed and show the Consent form to at least one other team member.",
  },
  {
    key: "signin_3",
    title: "State patient Allergies.",
  },
  {
    key: "signin_4",
    title:
      "State the Anesthesia plan, airway concerns, aspiration risk, anticipated blood loss, and monitoring readiness.",
  },
] as const;

export const ahoTimeOut = [
  {
    key: "timeout_1",
    title:
      "The team member leading the time out (physician or intra-procedural personnel) asks whether all team members are ready to proceed.",
  },
  {
    key: "timeout_2",
    title: "Any new team members introduce themselves.",
  },
  {
    key: "timeout_3",
    title: "State the patient's name, date of birth, and allergies.",
  },
  {
    key: "timeout_4",
    title: "Physicians performing the procedure will state the procedure, site, and side.",
  },
  {
    key: "timeout_5",
    title:
      "Physicians performing the procedure will verify the site and side with imaging or pathology, as applicable and verify that site marking is visible.",
  },
  {
    key: "timeout_6",
    title: "Verify prep is dry and fire risk has been discussed.",
  },
  {
    key: "timeout_7",
    title:
      "Physicians performing the procedure will review critical steps, potential blood loss, risks, and equipment needs and invite team members to voice concerns.",
  },
  {
    key: "timeout_8",
    title:
      "Anesthesia provider will state the antibiotic administered and administration time, as applicable.",
  },
] as const;
